module.exports = __webpack_public_path__ + "img/gsb12.040fe6da.png";